import { RelevanceTestsService } from 'src/services/RelevanceTestsService';

export const createRelevanceTestDefinition = async (
    {
        accessToken,
        data,
        signal,
    }: App.RelevanceTestDefinitions.CreateMutationVariables,
): Promise<Models.IngestConfigApi.RelevanceTests.RelevanceTestDefinition> => RelevanceTestsService
    .createRelevanceTestDefinition(
        accessToken,
        data,
        signal,
    );
